export default __webpack_public_path__ + "static/media/logo.ec4de410.png";